import { getCampaignTargetProviderHandlers } from "../campaign_target_provider_registry";
import { CampaignTargetProviderConfig } from "../../../common/campaign_target_provider";
import { Member, PublicCampaignTarget } from "@flow/common/types";

export function CampaignTargetLookup(props: {
  targetProviderConfig: CampaignTargetProviderConfig;
  member: Member;
  onUpdateMember: (member: Member) => void;
  onGetTarget: (targets: PublicCampaignTarget[]) => void;
}) {
  if (props.targetProviderConfig === undefined) {
    return <div>Campaign decision-maker targetting not configured!</div>;
  } else {
    const provider_unique_id = props.targetProviderConfig.provider_unique_id;
    const handler = getCampaignTargetProviderHandlers().get(provider_unique_id);

    if (handler === undefined) {
      return <div>Expected target lookup widget not found: {provider_unique_id}</div>;
    } else {
      const Widget = handler.memberTargetLookupWidget;

      return (
        <Widget
          config={handler.def.config_type.read(props.targetProviderConfig.config)}
          member={props.member}
          onUpdateMember={props.onUpdateMember}
          onGetTarget={props.onGetTarget}
        />
      );
    }
  }
}
